// This code is copied over from VPC
export module Helpers {
  export const DEFAULT_LETTER_T = 'T';
  function isLetter(char: string): boolean {
    return char.length === 1 && char.match(/[a-z]/i) != null;
  }

  // Extract leading English letters from the first two words
  // Return T to represent Tableau if no letter can generated
  export function generateAbbrevFromName(displayName: string): string {
    if (!displayName) return DEFAULT_LETTER_T;
    let abbrev = '';
    const words = displayName.trim().split(/\ +/);
    for (let i = 0; i < words.length && i < 2; ++i) {
      const initial: string = words[i].charAt(0);
      if (isLetter(initial)) {
        abbrev += initial.toUpperCase();
      }
    }
    return abbrev !== '' ? abbrev : DEFAULT_LETTER_T;
  }
}
